import * as React from "react"

import styled from "styled-components"

const ContainerLayout = ({ className, children, fullWidth, ...rest }) => {
  return (
    <ContainerStyled className={className} fullWidth={fullWidth} {...rest}>
      {children}
    </ContainerStyled>
  )
}

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: 100%;
  max-width: ${props => (props.fullWidth ? "100%" : "1170px")};
  width: 100%;
  margin: auto;
  padding: 6.5rem 0;

  position: relative;

  /* color: ${props => props.theme.colors.white}; */

  @media ${props => props.theme.breakpoints.desktop} {
    max-width: ${props => (props.fullWidth ? "100%" : "1080px")};
  }
  @media ${props => props.theme.breakpoints.large} {
    padding: ${props => (props.fullWidth ? "6.5rem 0" : "6.5rem 1rem")};
  }
  @media ${props => props.theme.breakpoints.medium} {
    align-items: center;
  }
  @media ${props => props.theme.breakpoints.tablet} {
    padding: 3.5rem ${props => (props.fullWidth ? "0" : "1rem")};
    max-width: 100%;
  }
`

export default ContainerLayout
